import React, { useContext } from 'react';

import AuthContext from 'common/auth';

import WalletSettings from 'components/WalletSettings';
import AccountSettings from 'components/AccountSettings';
import TimezoneSettings from 'components/TimezoneSettings';
import NotificationSettings from 'components/NotificationSettings';
import ChangePassword from 'components/ChangePassword';
import TwoFactorAuth from 'components/TwoFactorAuth';
import AccountData from 'components/AccountData';

const Settings = () => {
  const { user } = useContext(AuthContext)!;

  return (
    <>
      {!user?.is_superuser && <WalletSettings />}
      <AccountSettings />
      <TimezoneSettings />
      <NotificationSettings />
      <TwoFactorAuth />
      <ChangePassword />
      <AccountData />
    </>
  );
};

export default Settings;
